import { useFeatureEnabled } from "../../../IfFeatureEnabled";
import { useState } from "react";
import { TemplateDialog } from "./TemplateDialog";
import { useLocalUser } from "../data";
import { SplitButton } from "primereact/splitbutton";
import { ParsedTemplate, TemplateUseCase, useTemplates } from "./data";

export const TemplateButton = ({
  useCase,
  onOverrideTemplateVersion,
  suffix,
}: {
  useCase: TemplateUseCase;
  onOverrideTemplateVersion: (template: ParsedTemplate | undefined) => void;
  suffix?: string;
}) => {
  const canManageTemplates = useFeatureEnabled(
    "template-management",
    undefined,
    useLocalUser()
  );
  const templates = useTemplates(useCase, canManageTemplates);
  const [visible, setVisible] = useState(false);

  if (!canManageTemplates) return null;

  return (
    <>
      <SplitButton
        label={suffix ? `Manage ${suffix}` : "Manage"}
        onClick={() => setVisible(true)}
        tooltip="Manage template versions"
        tooltipOptions={{ showDelay: 500 }}
        raised
        text
        severity="secondary"
        model={[
          {
            label: "Use live version",
            command: () => onOverrideTemplateVersion(undefined),
          },
        ].concat(
          templates.data?.map((t) => ({
            label: `Test ${t.template_name}`,
            command: () => onOverrideTemplateVersion(t),
          })) ?? []
        )}
      />
      <TemplateDialog
        visible={visible}
        onHide={() => setVisible(false)}
        useCase={useCase}
      />
    </>
  );
};
